@use 'kci-design-lib/styles/variables.scss' as *;
.status {
  display: flex;
  width: 100%;
  .status-container {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .side-slot {
    flex: 1;
    display: flex;
    align-items: center;
    &.left {
      justify-content: flex-end;
      &:not(:empty) {
        padding-right: 4px;
      }
    }
    &.right {
      justify-content: flex-start;
      &:not(:empty) {
        padding-left: 4px;
      }
    }
  }
  .center-slot {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .status-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .status-svg-icon {
    display: block;
    flex-shrink: 0;
  }
  .status-text {
    white-space: nowrap;
    color: var(--status-text-color, var(--main-text));
    display: inline-block;
    vertical-align: middle;
  }
  &.status-only {
    .status-text {
      display: none;
    }
  }
}
.sizeSmall {
  .status-text {
    font-size: 12px;
    line-height: 18px;
    font-weight: 500;
    letter-spacing: 0.2px;
  }
}
.sizeRegular {
  .status-text {
    font-size: 14px;
    line-height: 20px;
    font-weight: 350;
    letter-spacing: 0.2px;
  }
}
.in-progress,
.error,
.complete,
.revisit,
.feature,
.future,
.download,
.warning,
.loading,
.ai-task,
.information,
.not-started,
.ready,
.shared,
.cleared,
.rejected,
.question,
.scheduled,
.new,
.draft,
.incomplete,
.pending {
  background-color: transparent;
  border: none;
}
.Icons_Background {
  background: transparent;
  border: none;
}
